
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import React from "react";
import { Col, Row } from "reactstrap";
import BaseLayout from "@components/BaseLayout";
/**
 * Cottbus-spezifische "So gehts"-Page
 */
const SoGehtsPage: React.FC = () => {
    const { t } = useTranslation("common");
    // const customerPreview: boolean = useSelector((state: AppState) =>
    //   state.applicationStates.settings.customerPreview
    // )
    return <BaseLayout pageTitle={t("page.index.title")} isFrontPage={true}>
    <div className="frontpage-content">
      <section className="on-white section-padding-tall text-center ">
        <Row className="no-flex text-center ">
          <h1>
            So funktioniert das IdeenLAB
          </h1>
          <h4 className="margin-top">
            Das IdeenLAB ist die Plattform und das Online-Tool der digitalen Stadt Cottbus/Chóśebuz,
            mit dem Du Deine Ideen in konkrete Projekte verwandelst. Ob allein oder mit Freund:innen und Bekannten:
            Mit Deinem Engagement leistest Du einen wertvollen Beitrag, um Anliegen der Bürger:innen von Cottbus
            im Bereich der digitalen Bildung positiv zu beeinflussen. Damit Dein Projekt ein echter Erfolg wird,
            unterstützt Dich das Community-Management-Team vom IdeenLAB mit Seminaren, Workshops und Treffen,
            die sowohl online als auch analog stattfinden. Dort kannst Du Dich nicht nur vernetzen,
            sondern auch Tipps und Tricks erhalten.
          </h4>
        </Row>
      </section>
      <section className="offset text-center ">
        <h2 className="dark">Die 3 Phasen</h2>
        <Row className="row-narrow">
          <Col><img src="/assets/img/cottbus/icon-ideen.svg"/><p><b>1. Ideen</b></p></Col>
          <Col><img src="/assets/img/cottbus/icon-projekte.svg"/><p><b>2. Projekte</b></p></Col>
          <Col><img src="/assets/img/cottbus/icon-wirkung.svg"/><p><b>3. Wirkung</b></p></Col>
        </Row>
      </section>
      <section>
        <Row>
          <Col>
            <h2>Einfach mitmachen</h2>
            <p>
              Die fortschreitende Digitalisierung eröffnet uns viele Möglichkeiten, unseren Alltag zu gestalten.
              Vielleicht hast Du neue Wege gefunden, um Deine täglichen Abläufe, Arbeitsprozesse, soziale Interaktionen
              oder Zusammenarbeit neu zu organisieren? Womöglich experimentierst Du auch mit neuen Herangehensweisen ans
              Lernen oder Lehren? In verschiedenen Lebensbereichen wie Kita, Schule, Studium, Arbeit oder anderen Kontexten
              bietet die Digitalisierung Vorteile und Chancen zur Teilhabe. Dennoch können Situationen auftreten, in denen
              Du den voranschreitenden Digitalisierungsprozess nicht optimal begleiten kannst. Was fehlt Dir,
              um mitzuwirken? Was müsste passieren, damit Du Dich einbezogener fühlst?
            </p>
            <p>
              Auf diese Fragen haben die Bürger:innen von Cottbus knapp 300 Anliegen formuliert und hier im
              IdeenLAB eingereicht. Daraus entstanden <Link href="/process/categories"><a>8 Aktionsfeldern</a></Link>, die zeigen, in welchen Bereichen sich
              Cottbuser:innen Lösungen wünschen. Vielleicht hast Du Ideen, wie Du dazu beitragen kannst? Und falls
              Du unabhängig der Anliegen eigene Ideen hast:  Solange sie der digitalen Bildung in unserer Stadt zu Gute
              kommen, <Link href="/projects"><a>teile sie gern mit!</a></Link>
            </p>
          </Col>
          {/* <Col className="col-1 display-none middle">
          <img src="/assets/img/cottbus/dots-white.svg" className="dots" />
          </Col>
        <Col className="middle">
          <p><b>Phase 1 ist abgeschlossen</b></p>
        </Col> */}
        </Row>
      </section>
      <section className="on-white">
        <Row>
          <Col>
            <h2>Von der Idee zum Projekt</h2>
            <p>
              Auf unserem <Link href="/projects"><a>Projektmarktplatz</a></Link> findest Du die Übersicht aller bislang
              eingereichten Ideen und daraus entstandenen Projekte. Mehr als einen kurzen Satz brauchst Du nicht,
              um Deine Idee <Link href="/ideas/create"><a>direkt einzureichen</a></Link>. Das IdeenLAB ist ein ideales Tool,
              um Dich bei der Umwandlung Deiner Idee in ein konkretes Projekt zu unterstützen. Denn hier kannst Du Dein
              Team finden sowie den Ablauf und die Umsetzung Eures Projektes einfach planen und organisieren.
            </p>
            <ul>
              <li>Erstelle Deinen persönlichen Account.</li>
              <li>Teile Deine Idee mit anderen.</li>
              <li>Unterstütze andere bei ihren Ideen.</li>
              <li>Erstelle ein Projektprofil.</li>
              <li>Plane die Projektumsetzung, in dem Du Aufgaben definierst, diese terminierst und mit Kosten versiehst.</li>
              <li>Finde Projektpartner:innen, die Dein Projekt unterstützen wollen.</li>
              <li>Gib ganz einfach Gesuche auf, um Unterstützung zu bekommen (Finanzierung, Werkzeug, Wissen o. ä.).</li>
              <li>Füge Teammitglieder zu Deinem Projekt hinzu.</li>
              <li>Tausche Dich in Deiner Gruppe aus und vernetze Dich.</li>
            </ul>
            <p>Nutze dazu die unterstützenden Funktionen des IdeenLAB – hier ist alles an einem Ort.</p>

          </Col>
          {/* <Col className="col-1 display-none middle">
          <img src="/assets/img/cottbus/dots-red.svg" className="dots" />
          </Col>
        <Col className="middle">
          <p><b>Mehr und mehr Ideen erscheinen auf der Plattform. Ist eine dabei, bei der Du mitmachen möchtest? Dann beteilige Dich aktiv oder finde für Deine eigene Idee Mitmacher:innen.</b></p>
        </Col>
        */}
        </Row>

      </section>
      <section>
        <Row>
          <Col>
            <h2>Ideen entwickeln, Wirkung spüren – es gibt viele gute Gründe</h2>
            <h5>
              Deshalb solltest auch Du beim IdeenLAB mitmachen:
            </h5>
            <ul>
              <li>Alle Projekte sind öffentlich sichtbar und bekommen Aufmerksamkeit.</li>
              <li>Die Ideen und Projekte inspirieren andere zum Mitmachen, Nachmachen und Weiterdenken.</li>
              <li>Du kannst Dich mit anderen zu einem Netzwerk engagierter Menschen zusammenfinden.</li>
              <li>Du erwirbst ggf. Wissen zu Fördermöglichkeiten.</li>
              <li>Du gestaltest den Wandel für ein digitales Cottbus aktiv mit…</li>
              <li>…und entfesselst mit Deinem Projekt kreative Energie.</li>
            </ul>

          </Col>
          {/* <Col className="col-1 display-none middle">
          <img src="/assets/img/cottbus/dots-white.svg" className="dots" />
        </Col>
        <Col className="middle">
          <p><b>Lass Deine Idee Wirklichkeit werden und starte mit der Umsetzung Deines Projektes.</b></p>
        </Col> */}
        </Row>
      </section>
      {/*  <section>
          <Row>
            <Col className="img-align"><img width="170px" src="/assets/img/cottbus/icon-happiness.svg" /></Col>
            <Col className="middle "><p>Im September 2024, zum Ende des Projektes IdeenLAB, finden sich alle entstandenen Projekte aus dem Bereich Bildung noch einmal zusammen, feiern ihre Geschichte und werden gegebenenfalls noch aktiv eigenständig weitergeführt!</p>
            </Col></Row>
        </section> */}
      <section className="on-white">
        <Row>
          <Col>
            <h2>Wer beim IdeenLAB mitmachen kann:</h2>
            <p className="margin-top">
              Alle Bürger:innen, die sich mit Cottbus verbunden fühlen, können mitmachen. Egal ob jung oder alt, ob digital zugewandt oder noch etwas unsicher im Umgang mit Internet, Tablet und Co.: Das IdeenLAB-Team freut sich auf Euch, Eure Ideen und Projekte. Es ist Euer Engagement, das die digitale Bildung in unserer Stadt nachhaltig weiterentwickelt und Cottbus ein Stück lebenswerter macht.
            </p>
            <ul>
              <li>Es sind keine Nachweise über die Meldung in Cottbus erforderlich.</li>
              <li>Ab 18 Jahren kannst Du ein Benutzerkonto beim IdeenLAB anlegen.</li>
              <li>Unter 18 Jahren kannst Du mit Vertreter:innen mitmachen, die 18 Jahre oder älter sind und ein Benutzerkonto beim IdeenLAB haben.</li>
              <li>Nicht teilnehmen dürfen das Projektteam und Projektpartner des IdeenLAB.</li>
            </ul>

          </Col>

          <Col>
            <h2>Wer hinter dem IdeenLAB steckt</h2>
            <p className="margin-top">
              Das Projekt IdeenLAB ist ein gemeinsames Vorhaben der Stadt Cottbus/Chóśebuz und der Brandenburgischen Technischen Universität Cottbus-Senftenberg. Mehr zum Hintergrund, der Idee und den Zielen des IdeenLAB:
              <br /><br />
              <Link href="/ueber"><a className="btn primary-btn margin-top">Übers IdeenLAB</a></Link>
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Link href="/"><a className=" btn primary-btn">Zurück zur Startseite</a></Link>
          </Col></Row>
      </section>

    </div>
  </BaseLayout>;
};
export default SoGehtsPage;

    async function __Next_Translate__getStaticProps__191dbbef742__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/so-gehts',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__191dbbef742__ as getStaticProps }
  